import { ICoherenceHeaderStyleProps, ICoherenceHeaderStyles } from '@coherence-design-system/controls';
import { IStyleFunctionOrObject } from '@fluentui/react';
import styled from 'styled-components';

export const HeaderRoot = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
`;

export const appHeaderStyles: IStyleFunctionOrObject<ICoherenceHeaderStyleProps, ICoherenceHeaderStyles> = () => {
  return {
    subComponentStyles: {
      appNameLink:{root: {color:"white !important"}},
    }
  }
};